<template>
  <DragDialog
    title="设置坐标参考"
    :width="600"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="tips-box">
      <div class="icon-box">
        <!-- <icon-svg icon-class="ic-zhuyi" /> -->
        <span class="text public-tips-primary">注：</span>
      </div>
      <div class="tips-content-box public-tips-primary">
        本平台仅支持使用Web墨卡托投影坐标系和分带投影坐标系。
      </div>
    </div>
    <div
      class="crs-params-type-box"
      v-if="dataSetType === 'Osgb'">
      <div class="radio-group-box">
        <el-radio-group
          class="radio-primary"
          v-model="crsParamsType"
          @change="handleCrsParamsTypeChange">
          <div class="common-radio-box">
            <el-radio label="Default">默认坐标参数</el-radio>
          </div>
          <div class="common-radio-box">
            <el-radio label="Custom">自定义坐标参数</el-radio>
          </div>
        </el-radio-group>
      </div>
    </div>
    <div
      class="osgb-coordinates-box"
      v-if="dataSetType === 'Osgb' && crsParamsType === 'Default'">
      <div class="label">坐标系：</div>
      <div
        class="crs-content text-overflow"
        :title="osgbCrs">
        {{ osgbCrs }}
      </div>
    </div>
    <div
      class="coordinates-box"
      v-if="crsParamsType !== 'Default'">
      <div class="title gr16">坐标系：</div>
      <div class="crs-form-box">
        <CrsForm
          ref="crsForm"
          dataType="dataSet"
          :disabled="false"
          :crsInfo="crsInfo" />
      </div>
    </div>
    <div class="offset-setting-box">
      <div
        class="basic-point-type"
        v-if="
          !isBatchConfig &&
          dataSetType !== 'Osgb' &&
          dataSetType !== 'Cad' &&
          dataSetType !== 'ModelGroup'
        ">
        <div class="radio-group-box">
          <el-radio-group
            class="radio-primary"
            v-model="basicPointType"
            @input="handleBasicPointTypeChange">
            <div class="common-radio-box">
              <el-radio label="Default">使用默认基点</el-radio>
            </div>
            <div class="common-radio-box">
              <el-radio label="Custom">自定义基点</el-radio>
            </div>
          </el-radio-group>
        </div>
      </div>
      <div class="basic-point-box">
        <div class="basic-point">
          <div class="label">基点(m)：</div>
          <div class="item-box">
            <div>x：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                v-model="basicPoint.x"
                :disabled="isBasicPointTypeDisable()" />
            </div>
          </div>
          <div class="item-box">
            <div>y：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                v-model="basicPoint.y"
                :disabled="isBasicPointTypeDisable()" />
            </div>
          </div>
          <div class="item-box">
            <div>z：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                v-model="basicPoint.z"
                :disabled="isBasicPointTypeDisable()" />
            </div>
          </div>
        </div>
      </div>
      <div class="north-angle-box">
        <div class="label">正北夹角(°)：</div>
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            v-model="basicPoint.angle"
            :disabled="isBasicPointTypeDisable()" />
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import CrsForm from '@/components/CrsForm.vue'

export default {
  data() {
    return {
      crsParamsType: 'Custom',
      crsInfo: {
        crsType: 'EPSG'
      },

      isBatchConfig: false,
      basicPointType: 'Default',
      basicPoint: {
        x: '0',
        y: '0',
        z: '0',
        angle: '0'
      },

      osgbCrs: ''
    }
  },
  props: {
    visible: Boolean,
    dataSetType: String,
    initCrsInfo: Object,
    submitInfo: Function,
    closeDialog: Function
  },
  components: {
    DragDialog,
    CrsForm
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initCrs()
      }
    }
  },
  methods: {
    initCrs() {
      this.setBasePoint()

      let { coordinatesConfig, isBatchConfig } = this.initCrsInfo
      if (isBatchConfig) {
        this.crsParamsType = 'Custom'
        this.basicPointType = 'Custom'
        this.isBatchConfig = true
      }

      if (this.dataSetType === 'Osgb') {
        let { coordinatesDefault } = this.initCrsInfo
        if (coordinatesDefault) {
          coordinatesDefault = JSON.parse(coordinatesDefault)
          this.osgbCrs = coordinatesDefault.Coordinates
        }
        if (!coordinatesConfig) {
          this.crsParamsType = 'Default'
          this.basicPointType = 'Default'
        } else {
          this.crsParamsType === 'Custom'
          this.basicPointType = 'Custom'
          this.crsInfo = this.getCrsInfo(coordinatesConfig)
        }
        return
      }

      this.crsInfo = this.getCrsInfo(coordinatesConfig)
    },
    getCrsInfo(coordinatesConfig) {
      let crsInfo = {
        crsType: 'EPSG',
        crsString: ''
      }
      if (!coordinatesConfig) return crsInfo

      coordinatesConfig = JSON.parse(coordinatesConfig)
      let coordinatesType = coordinatesConfig.CoordinatesType
      if (coordinatesType === 'None') {
        crsInfo = {
          crsType: 'None',
          crsString: ''
        }
      }

      if (coordinatesType === 'Default') {
        this.crsParamsType = 'Default'
        this.basicPointType = 'Default'
      }

      if (coordinatesType === 'EPSG' || coordinatesType === 'WKT') {
        crsInfo = {
          crsType: coordinatesType,
          crsString: coordinatesConfig.Coordinates
        }
      }

      if (coordinatesType === 'CalibrationPoint') {
        let { CoordinatesPoint } = coordinatesConfig
        if (CoordinatesPoint) {
          let point = CoordinatesPoint.Coordinates
          point = point.split(',')
          let x = point[0]
          let y = point[1]
          let z = point[2]
          // prettier-ignore
          let lng = CoordinatesPoint.Longitude ? CoordinatesPoint.Longitude : "";
          let lat = CoordinatesPoint.Latitude ? CoordinatesPoint.Latitude : ''

          crsInfo = {
            crsType: coordinatesType,
            x,
            y,
            z,
            lng,
            lat
          }
        }
      }

      return crsInfo
    },
    setBasePoint() {
      let { coordinatesConfig, coordinatesDefault } = this.initCrsInfo
      if (coordinatesDefault) {
        coordinatesDefault = JSON.parse(coordinatesDefault)
      } else {
        coordinatesDefault = {}
      }

      if (coordinatesConfig) {
        coordinatesConfig = JSON.parse(coordinatesConfig)
        let { BasePointType } = coordinatesConfig
        this.basicPointType = BasePointType
        if (BasePointType === 'Default') {
          let basePoint = coordinatesDefault.BasePoint
          let angle = coordinatesDefault.NorthAngle
          if (basePoint) {
            basePoint = basePoint.split(',')
            this.basicPoint.x = Number(basePoint[0])
            this.basicPoint.y = Number(basePoint[1])
            this.basicPoint.z = Number(basePoint[2])
          } else {
            this.basicPoint.x = 0
            this.basicPoint.y = 0
            this.basicPoint.z = 0
          }
          this.basicPoint.angle = angle ? angle : '0'
        } else {
          let basePoint = coordinatesConfig.BasePoint
          basePoint = basePoint.split(',')
          this.basicPoint.x = Number(basePoint[0])
          this.basicPoint.y = Number(basePoint[1])
          this.basicPoint.z = Number(basePoint[2])
          let angle = coordinatesConfig.NorthAngle
          this.basicPoint.angle = angle ? angle : '0'
        }
      } else {
        let basePoint = coordinatesDefault.BasePoint
        let angle = coordinatesDefault.NorthAngle
        if (basePoint) {
          basePoint = basePoint.split(',')
          this.basicPoint.x = Number(basePoint[0])
          this.basicPoint.y = Number(basePoint[1])
          this.basicPoint.z = Number(basePoint[2])
        } else {
          this.basicPoint.x = 0
          this.basicPoint.y = 0
          this.basicPoint.z = 0
        }
        this.basicPoint.angle = angle ? angle : '0'
      }

      if (this.dataSetType === 'Cad' || this.dataSetType === 'ModelGroup') {
        this.basicPointType = 'Custom'
      }
    },
    handleCrsParamsTypeChange(value) {
      if (value === 'Default') {
        let { coordinatesDefault } = this.initCrsInfo
        if (coordinatesDefault) {
          coordinatesDefault = JSON.parse(coordinatesDefault)
        } else {
          coordinatesDefault = {}
        }

        let basePoint = coordinatesDefault.BasePoint
        let angle = coordinatesDefault.NorthAngle
        if (basePoint) {
          basePoint = basePoint.split(',')
          this.basicPoint.x = basePoint[0]
          this.basicPoint.y = basePoint[1]
          this.basicPoint.z = basePoint[2]
        } else {
          this.basicPoint.x = 0
          this.basicPoint.y = 0
          this.basicPoint.z = 0
        }
        this.basicPoint.angle = angle ? angle : '0'
        if (this.dataSetType === 'Osgb') {
          this.basicPointType = 'Default'
        }
      } else {
        this.basicPoint.x = 0
        this.basicPoint.y = 0
        this.basicPoint.z = 0
        this.basicPoint.angle = '0'
      }
    },
    handleBasicPointTypeChange(value) {
      if (value === 'Default') {
        let { coordinatesDefault } = this.initCrsInfo
        if (coordinatesDefault) {
          coordinatesDefault = JSON.parse(coordinatesDefault)
        } else {
          coordinatesDefault = {}
        }

        let basePoint = coordinatesDefault.BasePoint
        let angle = coordinatesDefault.NorthAngle
        if (basePoint) {
          basePoint = basePoint.split(',')
          this.basicPoint.x = basePoint[0]
          this.basicPoint.y = basePoint[1]
          this.basicPoint.z = basePoint[2]
        } else {
          this.basicPoint.x = 0
          this.basicPoint.y = 0
          this.basicPoint.z = 0
        }
        this.basicPoint.angle = angle ? angle : '0'
      } else {
        this.basicPoint.x = 0
        this.basicPoint.y = 0
        this.basicPoint.z = 0
        this.basicPoint.angle = '0'
      }
    },
    submit() {
      this.getCoordinatesParams().then(params => {
        this.submitInfo(params).then(response => {
          if (response.isSuccess) {
            this.cancel()
          }
        })
      })
    },
    cancel() {
      this.crsParamsType = 'Custom'
      this.isBatchConfig = false
      if (this.$refs.crsForm) {
        this.crsInfo = {
          crsType: 'EPSG'
        }
        this.$refs.crsForm.clearForm()
      }
      this.resetBasicPoint()
      this.osgbCrs = ''

      this.closeDialog()
    },
    getCoordinatesParams() {
      return new Promise(resolve => {
        if (this.isBasicPointEmpty()) {
          this.$message.warning('基点坐标不能为空')
          return
        }
        let x = Number(this.basicPoint.x)
        let y = Number(this.basicPoint.y)
        let z = Number(this.basicPoint.z)
        let basePoint = `${x},${y},${z}`
        let params = {
          basePointType: this.basicPointType,
          basePoint,
          northAngle: `${Number(this.basicPoint.angle)}`
        }
        if (this.dataSetType === 'Osgb' && this.crsParamsType === 'Default') {
          params.coordinatesType = 'Default'
          params.coordinates = ''
          params.longitude = ''
          params.latitude = ''
          resolve(params)
          return
        }

        let crsParams = this.$refs.crsForm.getCrsParams()
        if (!crsParams) return
        params.coordinatesType = crsParams.coordinatesType
        params.coordinates = crsParams.coordinates
        params.longitude = crsParams.longitude
          ? `${Number(crsParams.longitude)}`
          : ''
        params.latitude = crsParams.latitude
          ? `${Number(crsParams.latitude)}`
          : ''

        if (!this.isNorthAngleValid(this.basicPoint.angle)) {
          let warningMsg = '正北夹角限制范围-180到180，小数部分最大长度3位'
          this.$message.warning(warningMsg)
          return
        }

        if (!this.isBasePointValid()) {
          let warningMsg = '基点整数部分最多9位，小数部分3位'
          this.$message.warning(warningMsg)
          return
        }

        resolve(params)
      })
    },
    isBasicPointEmpty() {
      let isEmpty = false
      let { x, y, z } = this.basicPoint

      if (x === '' || y === '' || z === '') {
        isEmpty = true
      }

      return isEmpty
    },
    resetBasicPoint() {
      this.basicPointType = 'Default'
      this.basicPoint = {
        x: '',
        y: '',
        z: '',
        angle: ''
      }
    },
    isBasePointValid() {
      if (this.basicPointType === 'Default') return true
      let basePoint = this.basicPoint
      if (
        this.isBasePointValueValid(basePoint.x) &&
        this.isBasePointValueValid(basePoint.y) &&
        this.isBasePointValueValid(basePoint.z)
      ) {
        return true
      } else {
        return false
      }
    },
    isBasePointValueValid(point) {
      point = Number(point).toString()
      let integerPart = point.split('.')[0]
      let decimalPart = point.split('.')[1]
      if (integerPart.length > 9 || (decimalPart && decimalPart.length > 3)) {
        return false
      } else {
        return true
      }
    },
    isNorthAngleValid(northAngle) {
      if (this.basicPointType === 'Default') return true

      northAngle = Number(northAngle)
      let string = northAngle.toString()
      let decimalPart = string.split('.')[1]
      let isValid = false
      if (northAngle > -180 && northAngle < 180) {
        if (decimalPart) {
          isValid = decimalPart.length < 4 ? true : false
        } else {
          isValid = true
        }
      } else {
        isValid = false
      }
      return isValid
    },
    isBasicPointTypeDisable() {
      let dataSetType = this.dataSetType
      let crsParamsType = this.crsParamsType
      let basicPointType = this.basicPointType
      if (dataSetType === 'Osgb') {
        if (crsParamsType === 'Custom') {
          return false
        } else {
          return true
        }
      } else {
        return basicPointType === 'Default'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.tips-box {
  display: flex;
  font-size: 12px;
  margin-top: -9px;
  margin-bottom: 18px;
  margin-left: -10px;
  color: var(--base-dark21-color);

  .icon-box {
    color: #73fbfd;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .text {
      margin-left: 10px;
    }
  }
}

.crs-params-type-box {
  display: flex;
  align-items: baseline;

  .radio-group-box {
    .el-radio-group {
      display: flex;

      .common-radio-box {
        // margin-right: 120px;
      }
    }
  }
}

.coordinates-box {
  color: var(--page-text-color);
  font-size: 14px;
  font-weight: 400;
  .title {
    margin: 16px 0px;
    font-size: 14px;
    color: var(--dialog-coordinates-title-color);
  }

  .crs-form-box {
    padding: 8px;
    border-radius: 8px;
    background-color: var(--crs-form-bg-color);
    border: 1px solid var(--crs-form-border-color);
  }
}

.osgb-coordinates-box {
  display: flex;
  color: var(--scene-dialog-text-color);
  margin-top: 16px;

  .label {
    flex-shrink: 0;
    text-align: right;
    font-size: 14px;
  }

  .crs-content {
    flex-grow: 1;
    font-size: 14px;
  }
}
.offset-setting-box {
  color: var(--dialog-coordinates-title-color);
  margin-top: 16px;
  .label {
    text-align: left;
    flex-shrink: 0;
    color: var(--dialog-coordinates-title-color);
    font-size: 14px;
  }

  .basic-point-type {
    display: flex;
    align-items: baseline;

    .radio-group-box {
      .el-radio-group {
        display: flex;

        .common-radio-box {
          // margin-right: 120px;
        }
      }
    }
  }

  .basic-point-box {
    display: flex;
    margin-top: 16px;
    line-height: 32px;

    .basic-point {
      display: flex;

      .label {
        text-align: right;
        color: var(--dialog-coordinates-title-color);
        font-size: 14px;
      }

      .item-box {
        display: flex;
        &:not(:last-child) {
          margin-right: 29px;
        }
        .common-input-box {
          margin-left: 5px;

          // :deep(.is-disabled) {
          //   .el-input__inner {
          //     &:hover {
          //       border: 1px solid var(--base-border-dark-color14) !important;
          //     }
          //   }
          // }
        }
      }
    }
  }
  .north-angle-box {
    display: flex;
    margin-top: 16px;
    line-height: 32px;

    .label {
      width: 94px;
    }

    .common-input-box {
      width: 120px;
      // :deep(.is-disabled) {
      //   .el-input__inner {
      //     &:hover {
      //       border: 1px solid var(--base-border-dark-color14) !important;
      //     }
      //   }
      // }
    }
  }
}
</style>
